import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

const scope = 'UserBar'
class UserBar extends Component {
  static propTypes = {
    user: PropTypes.object,
    onLogOut: PropTypes.func.isRequired,
  }

  renderUserInformation(user) {
    return (
      <Fragment>
        <div className={classnames(`${scope}-User`, 'info')} title="It's you!">
          <img alt='' className={classnames(`${scope}-Avatar`)} src={user.avatar} />
          <div className={classnames(`${scope}-Name`)}>{user.name}</div>
          <div className={`${scope}-Buttons`}>
            <a title='Manage Settings' href='/settings' className={classnames(`${scope}-Settings`)}>
              <i className='fa fa-cog' />
            </a>
            <a title='Log Out' className={classnames(`${scope}-Logout`)} href='/logout'>
              <i className='fa fa-sign-out-alt' />
            </a>
          </div>
        </div>
      </Fragment>
    )
  }

  renderLogInButton() {
    return (
      <Fragment>
        <div>
          <a title='Log In' className={classnames(`${scope}-Login`)} href='/api/login'>
            Log In
            <i className='fab fa-twitch' />
          </a>
        </div>
      </Fragment>
    )
  }

  render() {
    const { user } = this.props
    return <div className={scope}>{user ? this.renderUserInformation(user) : this.renderLogInButton()}</div>
  }
}

export default UserBar



// WEBPACK FOOTER //
// ./src/components/common/user-bar/user-bar.jsx